var _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "idea",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4468",
    "data-name": "Group 4468",
    transform: "translate(3.621 3.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4467",
    "data-name": "Group 4467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5874",
    "data-name": "Path 5874",
    d: "M74.752,73.675,72.6,71.521A.762.762,0,0,0,71.521,72.6l2.154,2.154a.762.762,0,0,0,1.077-1.077Z",
    transform: "translate(-71.298 -71.298)",
    fill: "#f89d1f"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4470",
    "data-name": "Group 4470",
    transform: "translate(0 12.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4469",
    "data-name": "Group 4469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5875",
    "data-name": "Path 5875",
    d: "M3.859,241H.762a.762.762,0,0,0,0,1.523h3.1a.762.762,0,1,0,0-1.523Z",
    transform: "translate(0 -241)",
    fill: "#f89d1f"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4472",
    "data-name": "Group 4472",
    transform: "translate(21.379 12.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5876",
    "data-name": "Path 5876",
    d: "M424.859,241h-3.1a.762.762,0,0,0,0,1.523h3.1a.762.762,0,0,0,0-1.523Z",
    transform: "translate(-421 -241)",
    fill: "#f89d1f"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4474",
    "data-name": "Group 4474",
    transform: "translate(18.702 3.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4473",
    "data-name": "Group 4473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5877",
    "data-name": "Path 5877",
    d: "M371.735,71.521a.761.761,0,0,0-1.077,0L368.5,73.675a.762.762,0,1,0,1.077,1.077l2.154-2.154A.762.762,0,0,0,371.735,71.521Z",
    transform: "translate(-368.281 -71.298)",
    fill: "#f89d1f"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4476",
    "data-name": "Group 4476",
    transform: "translate(12.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4475",
    "data-name": "Group 4475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5878",
    "data-name": "Path 5878",
    d: "M241.762,0A.761.761,0,0,0,241,.762v3.1a.762.762,0,1,0,1.523,0V.762A.761.761,0,0,0,241.762,0Z",
    transform: "translate(-241)",
    fill: "#f89d1f"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4478",
    "data-name": "Group 4478",
    transform: "translate(6.148 6.146)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4477",
    "data-name": "Group 4477"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5879",
    "data-name": "Path 5879",
    d: "M132.189,122.5a6.886,6.886,0,0,0-5.911-1.28,6.754,6.754,0,0,0-5,4.921,6.891,6.891,0,0,0,1.843,6.627,3.743,3.743,0,0,1,.99,2.61v.168a.754.754,0,0,0,.762.762h6.094a.754.754,0,0,0,.762-.762v-.168a3.781,3.781,0,0,1,1.051-2.656,6.878,6.878,0,0,0-.594-10.222Zm-4.266,3.093a2.228,2.228,0,0,0-2.2,1.645.762.762,0,1,1-1.479-.366,3.761,3.761,0,0,1,3.684-2.8.762.762,0,1,1,0,1.523Z",
    transform: "translate(-121.072 -121.024)",
    fill: "#f89d1f"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4480",
    "data-name": "Group 4480",
    transform: "translate(9.953 22.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4479",
    "data-name": "Group 4479"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5880",
    "data-name": "Path 5880",
    d: "M196,452v.762a2.288,2.288,0,0,0,2.285,2.285h1.523a2.288,2.288,0,0,0,2.285-2.285V452Z",
    transform: "translate(-196 -452)",
    fill: "#f89d1f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/project-icon.637768ef34b303b08cf9421d5a5c5d07.svg";
export { ForwardRef as ReactComponent };